<template>
  <div class= "neighborViewList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId">
            <el-option
              v-for="(item,index) in gardens"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addneighborView')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight552 : require('@/config/enum').tableheight132"
      >
        <el-table-column type="selection" width="55" v-if="this.neighborViewlistcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column 
          prop="content" 
          :label="$t('lang.lab_content')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.content }}
                </span>
              </div>
              <div>
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column 
          prop="red" 
          :label="$t('lang.lab_redpoint')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.red&&scope.row.red.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.red }}
                </span>
              </div>
              <div>
                {{ scope.row.red.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.red.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.red | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column 
          prop="blue" 
          :label="$t('lang.lab_bluepoint')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.blue&&scope.row.blue.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.blue }}
                </span>
              </div>
              <div>
                {{ scope.row.blue.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.blue.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.blue | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column 
          prop="supportCount" 
          :label="$t('lang.lab_numberofresponses')" 
          width="100px">
        </el-table-column>
        <el-table-column 
          :label="$t('lang.lab_percentageofvotes')"
          width="100px">
          <template slot-scope="scope">
            {{ scope.row.supportRed }}:{{scope.row.supportBlue}}
          </template>
        </el-table-column>
        <el-table-column 
          fixed="right"
          prop="operation" 
          :label="$t('lang.lab_operation')" 
          :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button @click="details(scope.row.id)">{{$t('lang.btn_detail')}}</el-button>
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:neighborViewList
 *@Description:众邻观点
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-04
 */
export default {
  data() {
    return {
      multipleSelection: [], // 多选框
      tableData: [], // 查询list
      gardenId: this.$store.getters.gardenId, // 绑定小区值
      gardens: [], // 小区范围
      type: '', // 1:楼 2：单元 3：房间
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
      neighborViewlistcheckbox: require('@/config/enum').neighborViewlistcheckbox // 是否隐藏复选框
    }
  },
  created() {
    setTimeout(() => {
         window.localStorage.setItem('neighborViewForm', '')
         window.localStorage.setItem('neighborViewSaveData', '')
      }, 200)
    this.selectGarden()
    this.getData()
  },
  methods: {
    // 小区下拉
    selectGarden() {
      let myGardens = [...this.$store.getters.userGardenList]
      let index = myGardens.findIndex(item => item.id === 0)
      if (index != -1) {
        myGardens.splice(index, 1)
      }
      this.gardens = myGardens
    },
    // 众邻观点-获取列表数据
    getData() {
      let loading = this.$loading()
      this.$get(`/courtroom?gardenId=${this.gardenId}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 新增
    add() {
      this.$router.push({ name: 'addNeighbor', query: { flag: false } })
    },
    // 详情
    details(id) {
      this.$router.push({ name: 'votingUsersList', query: { id: id } })
    },
    // 编辑
    edit(id) {
      this.$router.push({ name: 'editNeighbor', 
      query: { 
        id: id, 
        flag: true } })
    },
    // 删除
    deleteOne(id) {
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
          this.$delete(`/courtroom/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 查询
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
  }
}
</script>

<style lang="scss">
.el-tooltip__popper.is-light {
  max-width: 300px;
}
</style>